import React from "react";
import { NavLink } from "react-router-dom";

function Datenschutz() {
  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-center bg-footerBgColor text-white py-20 px-4">
      <div className="max-w-2xl w-full bg-[#23243a] rounded-xl shadow-lg p-8 relative">
        <NavLink to="/" className="absolute top-4 right-4">
          <img
            src="/images/logo-white.svg"
            alt="Diligent Logo"
            className="w-[120px] hover:opacity-80 transition-opacity"
          />
        </NavLink>
        <h1 className="text-3xl font-bold mb-6 text-center">
          Datenschutzerklärung
        </h1>
        <div className="space-y-5 text-base leading-relaxed">
          <div>
            <strong>1. Verantwortliche Stelle</strong>
            <br />
            Diligent Recruitment GmbH
            <br />
            Faberstrasse 11
            <br />
            76287 Rheinstetten
            <br />
            Deutschland
            <br />
            Telefon: +49 (0) 721-75401610
            <br />
            Mobil: +49 (0) 152 24076038
            <br />
            Mobil: +49 (0) 152 26712572
            <br />
            E-Mail: info@diligentgermany.de
            <br />
            Web: www.diligentgermany.de
            <br />
            Geschäftsführer: Shawn Siegrist, Jochen Sagert
            <br />
            Registergericht: Mannheim
            <br />
            Handelsregisternummer: HRB740899
            <br />
            USt-IdNr: DE345879438
          </div>
          <div>
            <strong>2. Personenbezogene Daten, die wir verarbeiten</strong>
            <br />
            Wir verarbeiten folgende Arten von personenbezogenen Daten:
            <ul className="list-disc ml-6">
              <li>
                <strong>Bei der Registrierung:</strong> Name, E-Mail-Adresse,
                Firmenname, Adresse, Telefonnummer
              </li>
              <li>
                <strong>Bei der Terminvereinbarung:</strong> Name,
                E-Mail-Adresse, Telefonnummer
              </li>
              <li>
                <strong>Bei der Nutzung der Plattform:</strong> IP-Adresse,
                Datum und Uhrzeit des Zugriffs, Browsertyp, Cookie-IDs,
                Nutzungsverhalten.
              </li>
              <li>
                <strong>CV-Anonymizer:</strong> Hochgeladene Lebenslauf-PDFs 
                mit persönlichen Daten (Name, Adresse, E-Mail, Telefonnummer, 
                Geburtsdatum, Arbeitgeber, Bildungseinrichtungen etc.).
              </li>
              <li>
                <strong>Daten von externen Jobportalen:</strong> Die von uns
                verarbeiteten Jobanzeigen enthalten möglicherweise
                personenbezogene Daten (z.B. Namen von Unternehmen,
                Ansprechpartner). Wir verarbeiten diese Daten nur, um die
                Jobanzeigen anzuzeigen.
              </li>
            </ul>
          </div>
          <div>
            <strong>3. Zweck der Datenverarbeitung</strong>
            <ul className="list-disc ml-6">
              <li>Registrierung und Verwaltung deines Kontos.</li>
              <li>Vereinbarung und Durchführung von Terminen.</li>
              <li>
                CV-Anonymisierung: Entfernung persönlicher Daten aus Lebensläufen 
                mittels KI-gestützter Erkennung und Schwärzung.
              </li>
              <li>
                Analyse und Marketing: Statistische Auswertung des
                Nutzerverhaltens und Schaltung personalisierter Werbung
                (Retargeting).
              </li>
              <li>
                Verbesserung unserer Plattform und Erfüllung gesetzlicher
                Pflichten.
              </li>
            </ul>
          </div>
          <div>
            <strong>4. Rechtsgrundlage der Datenverarbeitung</strong>
            <br />
            Die Rechtsgrundlage ist in der Regel deine Einwilligung (Art. 6
            Abs. 1 lit. a DSGVO) für Marketing-Tools oder die Erfüllung eines
            Vertrags (Art. 6 Abs. 1 lit. b DSGVO).
          </div>
          <div>
            <strong>5. Cookies und ähnliche Technologien</strong>
            <br />
            Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf deinem Gerät gespeichert werden. 
            Wir unterscheiden zwischen:
            <ul className="list-disc ml-6 mt-2">
              <li>
                <strong>Technisch notwendige Cookies:</strong> Diese sind für den Betrieb der Website erforderlich und können nicht deaktiviert werden.
              </li>
              <li>
                <strong>Funktionale Cookies:</strong> Diese ermöglichen erweiterte Funktionen wie die Nutzung unserer APIs (z.B. CV-Anonymisierung).
              </li>
              <li>
                <strong>Analyse-Cookies:</strong> Diese helfen uns zu verstehen, wie Besucher unsere Website nutzen.
              </li>
              <li>
                <strong>Marketing-Cookies:</strong> Diese werden verwendet, um dir relevante Werbung anzuzeigen.
              </li>
            </ul>
            <br />
            Du kannst deine Cookie-Einstellungen jederzeit über den Link "Cookie-Einstellungen" im Footer ändern.
          </div>
          <div>
            <strong>6. Consent-Management (Klaro!)</strong>
            <br />
            Wir setzen das Open-Source Consent-Management-Tool „Klaro!" ein. 
            Dieses Tool speichert deine Entscheidung zur Einwilligung in die Nutzung von Cookies lokal in deinem Browser. 
            Die Einwilligung wird nicht an externe Server übertragen, sondern bleibt vollständig auf deinem Gerät gespeichert.
            Du kannst deine Einwilligung jederzeit über den Link "Cookie-Einstellungen" im Footer widerrufen oder anpassen.
          </div>
          <div>
            <strong>7. Einsatz von Analyse- und Marketing-Tools</strong>
            <br />
            Wir nutzen Tools von Drittanbietern, um die Nutzung unserer Website
            zu analysieren und Werbung zu optimieren. Die Daten können dabei an
            Server in den USA übertragen werden.
            <ul className="list-disc ml-6 mt-2">
              <li>
                <strong>Google Tag Manager:</strong> Dieses Tool verwaltet
                andere Tracking-Tags. Der Tag Manager selbst setzt keine
                Cookies, regelt aber die Auslösung anderer Skripte.
              </li>
              <li>
                <strong>Google Analytics 4 (GA4):</strong> Erfasst
                anonymisierte Daten über deine Nutzung der Website (z. B.
                Verweildauer, geklickte Seiten).
              </li>
              <li>
                <strong>Google Ads & Conversion Tracking:</strong> Wir messen,
                ob du über eine Google-Anzeige zu uns gekommen bist, um unsere
                Werbeausgaben zu optimieren.
              </li>
              <li>
                <strong>LinkedIn Insight Tag:</strong> Wir nutzen dieses Tool
                für Retargeting und Analysen. Es ermöglicht uns, Besuchern
                unserer Website relevante Werbung auf LinkedIn anzuzeigen und
                Statistiken über die Interaktion mit unseren Anzeigen zu
                erhalten.
              </li>
            </ul>
          </div>
          <div>
            <strong>8. Weitergabe von Daten an Dritte</strong>
            <br />
            Wir geben deine Daten nur an die oben genannten Dienstleister
            (Google, LinkedIn, Klaro!, Amazon Web Services) im Rahmen der 
            Auftragsverarbeitung weiter. Eine darüber hinausgehende Weitergabe 
            erfolgt nur bei gesetzlicher Verpflichtung oder ausdrücklicher Einwilligung.
          </div>
          <div>
            <strong>9. Daten von externen Jobportalen</strong>
            <br />
            Externe Jobportale haben eigene Datenschutzbestimmungen. Bitte
            informiere dich dort, wenn du diese Portale direkt nutzt.
          </div>
          <div>
            <strong>10. CV-Anonymizer (Lebenslauf-Anonymisierung)</strong>
            <br />
            Unser CV-Anonymizer ermöglicht es dir, persönliche Daten aus deinem 
            Lebenslauf zu entfernen. Dabei verarbeiten wir folgende Daten:
            <ul className="list-disc ml-6 mt-2">
              <li>
                <strong>Original-Lebenslauf:</strong> Die hochgeladene PDF-Datei 
                wird verschlüsselt auf unseren Servern (Amazon Web Services S3, EU) 
                gespeichert und nach 30 Tagen automatisch gelöscht.
              </li>
              <li>
                <strong>KI-gestützte Verarbeitung:</strong> Zur Erkennung sensibler 
                Daten nutzen wir die Google Gemini API. Der Textinhalt deines CVs 
                wird dabei an Google übermittelt (verschlüsselt). Google speichert 
                diese Daten gemäß der Google Cloud Datenschutzrichtlinien.
              </li>
              <li>
                <strong>Anonymisierte Version:</strong> Die anonymisierte PDF wird 
                NICHT gespeichert, sondern direkt an dich übermittelt und danach gelöscht.
              </li>
            </ul>
            <br />
            <strong>Rechtsgrundlage:</strong> Deine ausdrückliche Einwilligung bei 
            der Nutzung des Tools (Art. 6 Abs. 1 lit. a DSGVO).
            <br />
            <strong>Drittanbieter:</strong>
            <ul className="list-disc ml-6 mt-2">
              <li>
                Amazon Web Services (AWS S3) – Serverstandort: EU, 
                Datenschutz: <a href="https://aws.amazon.com/de/privacy/" 
                className="underline text-[#B588FF]" target="_blank" rel="noopener noreferrer">
                  aws.amazon.com/privacy
                </a>
              </li>
              <li>
                Google Gemini API – Datenschutz: <a href="https://cloud.google.com/privacy" 
                className="underline text-[#B588FF]" target="_blank" rel="noopener noreferrer">
                  cloud.google.com/privacy
                </a>
              </li>
            </ul>
            <br />
            <strong>Speicherdauer:</strong> Original-CVs werden nach 30 Tagen automatisch 
            gelöscht. Du kannst jederzeit die sofortige Löschung verlangen.
          </div>
          <div>
            <strong>11. Speicherung von Daten</strong>
            <br />
            Wir speichern deine Daten nur so lange, wie es für die Zwecke
            erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen.
          </div>
          <div>
            <strong>12. Deine Rechte</strong>
            <br />
            Du hast das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art.
            16 DSGVO), Löschung (Art. 17 DSGVO), Einschränkung der Verarbeitung
            (Art. 18 DSGVO) sowie das Recht auf Datenübertragbarkeit und
            Widerspruch (Art. 21 DSGVO). Deine Einwilligung kannst du jederzeit
            über den Cookie-Banner widerrufen.
          </div>
          <div>
            <strong>13. Kontakt</strong>
            <br />
            Diligent Recruitment GmbH
            <br />
            Faberstrasse 11
            <br />
            76287 Rheinstetten
            <br />
            Deutschland
            <br />
            Telefon: +49 (0) 721-75401610
            <br />
            Mobil: +49 (0) 152 24076038
            <br />
            Mobil: +49 (0) 152 26712572
            <br />
            E-Mail:{" "}
            <a
              href="mailto:info@diligentgermany.de"
              className="underline text-[#B588FF]"
            >
              info@diligentgermany.de
            </a>
            <br />
            Web: www.diligentgermany.de
          </div>
          <div>
            <strong>14. Änderungen der Datenschutzerklärung</strong>
            <br />
            Wir behalten uns das Recht vor, diese Erklärung bei Bedarf zu
            ändern.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Datenschutz;
